import { Injectable } from "@angular/core";
import { City } from "src/app/cities/city";
import { Observable, BehaviorSubject } from "rxjs";
import { map,tap } from "rxjs/operators";
import { HttpClient} from "@angular/common/http";
import { environment } from "src/environments/environment";
import { MessagerComponent } from "src/app/messager/messager/messager.component";

@Injectable({
  providedIn: "root",
})
export class CityService {
  private baseURL = environment.baseUrl;
  private subject = new BehaviorSubject<City[]>([]);

  gridObject$: Observable<City[]> = this.subject.asObservable();
  isLoading = true;

  constructor(private http: HttpClient, private messager: MessagerComponent) {}

  init() {
    const http$ = this.gridHttp();

    http$
      .pipe(
        tap(() => {
          this.isLoading = false;
        })
      )
      .subscribe((res) => this.subject.next(res.city));
  }

  saveEdit(id: number, changes): Observable<any> {
    const citys = this.subject.getValue();

    const cityIndex = citys.findIndex((city) => city.city_id === id);
    const newcityList = citys.slice(0);


    newcityList[cityIndex] = {
      ...citys[cityIndex],
      ...changes,
    };

    this.subject.next(newcityList);
    return this.http
      .post(this.baseURL + "/rhAPI/city/edit/" + id, changes)
      .pipe(
        tap((event) => {
          const message = event.Message as unknown as string;
          if (event.Error) {
            this.messager.openSnackBar(message, "Close", "errorAlert");
            this.subject.next(citys);
          } else {
            this.messager.openSnackBar(message, "", "successAlert");
          }
        })
      );
  }

  getInitial() {
    return this.gridObject$.pipe(map((objects) => objects));
  }

  gridHttp(): Observable<any> {
    return this.http.get<City[]>(this.baseURL + "/rhAPI/city", {
      observe: "body",
    });
  }

  getRegions(): Observable<any> {
    return this.http.get<any>(this.baseURL + "/rhAPI/city/getRegions")
      .pipe(
        map(response => {
          if (response.Error) {
            return []
          }
          return response.regions.map(item => ({
            value: item.region,
            viewValue: item.region
          }));
        })
      );
  }

  getOneCity(id: number): Observable<any> {
    return this.http.get(this.baseURL + "/rhAPI/city/getOneCity/" + id).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, "Close", "errorAlert");
        } else {
          this.messager.openSnackBar(message, "Editing...", "successAlert");
        }
      })
    );
  }

  add(changes): Observable<any> {
    const list = this.subject.getValue();
    const newList = list.slice(0);

    newList.unshift(changes);

    this.subject.next(newList);

    return this.http.post(this.baseURL + "/rhAPI/city/add", changes).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, "Close", "errorAlert");
          this.subject.next(list);
        } else {
          this.messager.openSnackBar(message, "", "successAlert");
        }
      })
    );
  }

  deleteOne(id: number) {
    const originalList = this.subject.getValue();
    const index = originalList.findIndex((object) => object.city_id === id);

    const newList = originalList.slice(0);

    newList.splice(index, 1);
    this.subject.next(newList);
  }
}
